<template>
  <div class="order-result container">
    <div v-if="orderInfo.orderNum">
      <FloorBanner :orderInfo="orderInfo" :isSM="isSM" :isSF="isSF"></FloorBanner>
      <FloorFlow :orderInfo="orderInfo" :isSM="isSM" :isSF="isSF"></FloorFlow>
      <FloorProcess :orderInfo="orderInfo" :isSM="isSM" :isSF="isSF"></FloorProcess>
      <FloorWarn :orderInfo="orderInfo" :isSM="isSM" :isSF="isSF"></FloorWarn>
      <FloorLogic :orderInfo="orderInfo" :isSM="isSM" :isSF="isSF"></FloorLogic>
    </div>
  </div>
</template>

<script>
import CreatedOrder from '@/core/createdOrder/store';
import FloorBanner from './floor-banner';
import FloorFlow from './floor-flow';
import FloorProcess from './floor-process';
import FloorWarn from './floor-warn';
import FloorLogic from './floor-logic';
import { MessageBox } from 'element-ui';
import { getTempOrder } from '@/apis/base';

export default {
  components: {
    FloorBanner,
    FloorFlow,
    FloorProcess,
    FloorWarn,
    FloorLogic
  },
  registerModule (store, preserveState) {
    store.registerModule('createdOrder', CreatedOrder, { preserveState });
  },
  destroyed () {
    if (this.expireMessageBox) {
      this.expireMessageBox.doClose();
    }
    this.$store.unregisterModule('createdOrder');
  },
  data () {
    return {
      orderInfo: {}
    };
  },
  computed: {
    errInfo () {
      return this.$store.state.createdOrder.errInfo;
    },
    isSM () {
      return this.Q_CONST.RECYCLE_TYPE.SM === this.orderInfo.recycleType;
    },
    isSF () {
      return this.Q_CONST.RECYCLE_TYPE.SF === this.orderInfo.recycleType;
    }
  },
  async mounted () {
    let result = await getTempOrder(this.$route.params.orderNum);
    if (result._errCode === '0') {
      this.orderInfo = result._data;
    } else if (result._errCode === '400008') {
      this.expireMessageBox = MessageBox({
        type: 'info',
        title: '系统提示',
        message: '页面已过期，点击确认将返回首页'
      }).then(() => {
        this.$router.push('/');
      }).catch(() => {
        this.$router.push('/');
      });
    }
  }
};
</script>

<style lang="postcss" scoped>
.order-result {
  margin-bottom: 30px;

  /deep/ .floor {
    overflow: hidden;
    margin-top: 10px;
    background-color: #fff;
  }
  /deep/ .floor__hd {
    padding: 20px 0;
    margin-bottom: 20px;
    margin-left: 40px;
    margin-right: 40px;
    font-size: 16px;
    color: #666666;
    border-bottom: 1px solid #f5f5f5;
  }
  /deep/ .floor__bd {
    font-size: 16px;
    line-height: 24px;
    padding-left: 40px;
    padding-right: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/orderResult/index.vue